// AdminFrontend/src/unicodex_ui/admin/services/adminAuthApi.js
import adminApi from "./adminApiClient";

/**
 * Admin login.
 * POST /api/admin/auth/login
 */
export async function adminLogin(email, password) {
  const res = await adminApi.post("/api/admin/auth/login", { email, password });
  return res.data; // { ok, token, admin }
}
